export default "/images/error.svg?662efd961a7703196629504436d30dd5";